import React from 'react'

const IconArrowSwipeRight = () => {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.40866 15.7115L9.12012 8.00003L1.40866 0.288574L0.28845 1.40878L6.87991 8.00003L0.28845 14.5913L1.40866 15.7115Z" />
    </svg>
  )
}

export default IconArrowSwipeRight
